import {Component, Input, OnInit} from '@angular/core';
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {CONTACT_PHONE} from "../../constants";

@Component({
    selector: 'app-chats',
    templateUrl: './chats.component.html',
    styleUrls: ['./chats.component.scss'],
})
export class ChatsComponent implements OnInit {

    public showContacts: boolean = false;
    public chatLink:string = "https://leeloo.greencountry.com.ua/5u02ww";
    @Input() page: boolean = false;

    constructor( public myGcService: MyGreenCountry) {
    }

    ngOnInit() {
    }


    toggleContacts() {
        this.showContacts = !this.showContacts;
    }

    openUrl() {

        this.myGcService.openUrl(this.chatLink)

    }

    protected readonly CONTACT_PHONE = CONTACT_PHONE;
}
